module.exports = require("./lib/_stream_passthrough.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/readable-stream/passthrough.js
 ** module id = 1640
 ** module chunks = 0
 **/